import type { PatientDto } from './patientTrackingTypes';
import {
  RecordDetailGrid,
  RecordDetailGridFull,
  RecordDetailHero,
  RecordDetailItem,
  RecordDetailPanel,
  RecordDetailView,
  type RecordDetailBadge
} from './RecordDetailView';
import './recordDetailView.css';

function formatAddress(p: PatientDto): string {
  const parts = [
    p.addressLine1,
    p.addressLine2,
    [p.city, p.state].filter(Boolean).join(', '),
    p.postalCode
  ].filter((x) => x?.trim());
  return parts.join('\n');
}

export function PatientDetailView({ patient }: { patient: PatientDto }) {
  const badges: RecordDetailBadge[] = [];
  badges.push({
    text: patient.isActive ? 'Active' : 'Inactive',
    tone: patient.isActive ? 'success' : 'danger'
  });
  if (patient.enrollmentForm) badges.push({ text: 'Enrollment on file', tone: 'neutral' });
  if (patient.openIssues > 0) {
    badges.push({ text: `${patient.openIssues} open issue${patient.openIssues === 1 ? '' : 's'}`, tone: 'warning' });
  }

  const address = formatAddress(patient);

  return (
    <RecordDetailView>
      <RecordDetailHero
        title={patient.fullName}
        subtitle={patient.pharmacyName ?? undefined}
        badges={badges}
      />

      <RecordDetailPanel title="Demographics">
        <RecordDetailGrid>
          <RecordDetailItem label="Date of birth" value={patient.dob} />
          <RecordDetailItem label="Home covered entity" value={patient.homeCoveredEntityName} />
          <RecordDetailItem label="Total issues" value={String(patient.totalIssues)} />
          <RecordDetailItem label="Open issues" value={String(patient.openIssues)} />
        </RecordDetailGrid>
      </RecordDetailPanel>

      <RecordDetailPanel title="Contact">
        <RecordDetailGrid>
          <RecordDetailItem label="Phone" value={patient.phone} />
          <RecordDetailItem label="Email" value={patient.email} />
        </RecordDetailGrid>
      </RecordDetailPanel>

      <RecordDetailPanel title="Address">
        <RecordDetailGrid columns={1}>
          <RecordDetailGridFull>
            <RecordDetailItem label="Mailing address" value={address} multiline />
          </RecordDetailGridFull>
        </RecordDetailGrid>
      </RecordDetailPanel>

      <RecordDetailPanel title="Notes">
        <RecordDetailGrid columns={1}>
          <RecordDetailGridFull>
            <RecordDetailItem label="Patient notes" value={patient.notes} multiline />
          </RecordDetailGridFull>
        </RecordDetailGrid>
      </RecordDetailPanel>
    </RecordDetailView>
  );
}
